/* ========================================
   Artist Profile — Klydos Grid + Carousel
   ======================================== */

function renderKlydos(klydos, artistId) {
  const grid = document.getElementById('klydos-grid');
  const section = document.getElementById('section-klydos');
  const arrowLeft = document.getElementById('klydos-arrow-left');
  const arrowRight = document.getElementById('klydos-arrow-right');
  const klydosViewAll = document.getElementById('klydos-view-all');
  if (klydosViewAll && artistId) {
    klydosViewAll.href = '/pages/artist-all-klydos?id=' + encodeURIComponent(artistId);
  }

  const now = Date.now();
  const publishedKlydos = (klydos || []).filter(function(klydo) {
    return !klydo.publicTimestamp || klydo.publicTimestamp < now;
  });

  if (publishedKlydos.length === 0) {
    section.style.display = 'none';
    return;
  }

  if (klydosViewAll) {
    klydosViewAll.style.display = publishedKlydos.length > 8 ? '' : 'none';
  }

  const sorted = publishedKlydos.slice().sort(function(klydoA, klydoB) {
    const favA = (klydoA.stats && klydoA.stats.favorites) || 0;
    const favB = (klydoB.stats && klydoB.stats.favorites) || 0;
    return favB - favA;
  }).slice(0, 12);

  grid.innerHTML = sorted.map(function(klydo, index) {
    const imageUrl = klydo.photoUrl || klydo.loopUrl || klydo.theme || '';
    const mediaHtml = '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(klydo.name) + '">';
    return '<div class="artist-klydo-card" data-klydo-index="' + index + '">' +
      '<div class="artist-klydo-card__media-wrap">' + mediaHtml + '</div>' +
      '<div class="artist-klydo-card__name">' + escapeHtml(klydo.name || '') + '</div>' +
    '</div>';
  }).join('');

  grid.addEventListener('click', function(event) {
    const card = event.target.closest('.artist-klydo-card');
    if (!card) return;
    const idx = parseInt(card.getAttribute('data-klydo-index'), 10);
    if (!isNaN(idx) && sorted[idx]) {
      openKlydoModal(sorted[idx]);
    }
  });

  if (sorted.length <= 1) {
    arrowLeft.style.display = 'none';
    arrowRight.style.display = 'none';
    return;
  }

  grid.classList.add('artist-klydos__grid--scroll');

  function isMobile() {
    return window.innerWidth <= 760;
  }

  if (isMobile()) {
    setupMobileScroll();
    return;
  }

  setupDesktopCarousel();

  /* ---- Mobile: infinite touch scroll ---- */
  function setupMobileScroll() {
    const wrapper = grid.parentElement;
    const cards = Array.from(grid.children);
    const totalCards = cards.length;

    /* Build track with 3 copies: [clone] [original] [clone] */
    const track = document.createElement('div');
    track.className = 'artist-klydos__track';
    track.style.display = 'flex';
    track.style.gap = '20px';

    /* Prepend clones */
    cards.forEach(function(card) {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    /* Originals */
    cards.forEach(function(card) {
      track.appendChild(card);
    });
    /* Append clones */
    cards.forEach(function(card) {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    grid.innerHTML = '';
    grid.appendChild(track);
    grid.style.overflow = 'visible';

    wrapper.style.overflow = 'auto';
    wrapper.style.webkitOverflowScrolling = 'touch';
    arrowLeft.style.display = 'none';
    arrowRight.style.display = 'none';

    /* Hide scrollbar */
    wrapper.style.scrollbarWidth = 'none';
    wrapper.style.msOverflowStyle = 'none';

    /* Click handler on track (covers clones too) */
    track.addEventListener('click', function(event) {
      const card = event.target.closest('.artist-klydo-card');
      if (!card) return;
      const idx = parseInt(card.getAttribute('data-klydo-index'), 10);
      if (!isNaN(idx) && sorted[idx]) {
        openKlydoModal(sorted[idx]);
      }
    });

    /* Measure one set width after layout */
    let oneSetWidth = 0;
    let isTouching = false;

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        /* Calculate width of one set of cards */
        const cardWidth = track.children[0].offsetWidth;
        const gap = 20;
        oneSetWidth = totalCards * cardWidth + totalCards * gap;

        /* Start at the originals (second set) */
        wrapper.scrollLeft = oneSetWidth;
      });
    });

    wrapper.addEventListener('touchstart', function() {
      isTouching = true;
    }, { passive: true });

    wrapper.addEventListener('touchend', function() {
      isTouching = false;
      /* Check after momentum scrolling settles */
      checkWrap();
    }, { passive: true });

    let rafId = null;
    function checkWrap() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function() {
        if (isTouching || oneSetWidth === 0) return;

        const scrollPos = wrapper.scrollLeft;

        /* If scrolled into the first clone set (before originals) */
        if (scrollPos < oneSetWidth * 0.3) {
          wrapper.style.scrollBehavior = 'auto';
          wrapper.scrollLeft = scrollPos + oneSetWidth;
          wrapper.style.scrollBehavior = '';
        }
        /* If scrolled into the third clone set (after originals) */
        else if (scrollPos > oneSetWidth * 1.7) {
          wrapper.style.scrollBehavior = 'auto';
          wrapper.scrollLeft = scrollPos - oneSetWidth;
          wrapper.style.scrollBehavior = '';
        }
      });
    }

    /* Also check on scroll end for momentum */
    let scrollTimer;
    wrapper.addEventListener('scroll', function() {
      if (isTouching) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(checkWrap, 100);
    }, { passive: true });
  }

  /* ---- Desktop: arrow-based carousel with clones ---- */
  function setupDesktopCarousel() {
    const track = document.createElement('div');
    track.className = 'artist-klydos__track';
    while (grid.firstChild) track.appendChild(grid.firstChild);
    grid.appendChild(track);

    const originalCards = Array.from(track.children);
    const totalOriginal = originalCards.length;

    originalCards.forEach(function(card) {
      track.appendChild(card.cloneNode(true));
    });
    for (let cloneIndex = totalOriginal - 1; cloneIndex >= 0; cloneIndex--) {
      track.insertBefore(originalCards[cloneIndex].cloneNode(true), track.firstChild);
    }

    track.addEventListener('click', function(event) {
      const card = event.target.closest('.artist-klydo-card');
      if (!card) return;
      const idx = parseInt(card.getAttribute('data-klydo-index'), 10);
      if (!isNaN(idx) && sorted[idx]) {
        openKlydoModal(sorted[idx]);
      }
    });

    const GAP = 42;
    let isAnimating = false;
    let currentIndex = totalOriginal;
    let cachedStep = 0;

    function getStep() {
      if (cachedStep > 0) return cachedStep;
      const firstCard = track.children[0];
      if (firstCard && firstCard.offsetWidth > 0) {
        cachedStep = firstCard.offsetWidth + GAP;
      }
      return cachedStep || (191 + GAP);
    }

    function jumpTo(index) {
      track.style.transition = 'none';
      currentIndex = index;
      track.style.transform = 'translateX(' + (-(currentIndex * getStep())) + 'px)';
      track.offsetHeight;
    }

    function animateTo(index) {
      currentIndex = index;
      track.style.transition = 'transform 0.35s ease';
      track.style.transform = 'translateX(' + (-(currentIndex * getStep())) + 'px)';
    }

    requestAnimationFrame(function() {
      cachedStep = 0;
      jumpTo(totalOriginal);
    });

    arrowLeft.classList.remove('artist-klydos__arrow--hidden');
    arrowRight.classList.remove('artist-klydos__arrow--hidden');

    track.addEventListener('transitionend', function() {
      isAnimating = false;
      if (currentIndex < totalOriginal) {
        jumpTo(currentIndex + totalOriginal);
      } else if (currentIndex >= totalOriginal * 2) {
        jumpTo(currentIndex - totalOriginal);
      }
    });

    arrowLeft.addEventListener('click', function() {
      if (isAnimating) return;
      isAnimating = true;
      animateTo(currentIndex - 1);
    });

    arrowRight.addEventListener('click', function() {
      if (isAnimating) return;
      isAnimating = true;
      animateTo(currentIndex + 1);
    });

    window.addEventListener('resize', function() {
      if (!isMobile()) {
        cachedStep = 0;
        jumpTo(totalOriginal);
      }
    });
  }
}
